export default __webpack_public_path__ + "static/media/header_web.abd5f027.jpg";